module.exports = __webpack_public_path__ + "img/exchange_2.c2246dd7.svg";